export const getCommonRedirectLink = (clientId, year) =>
  `/admin/clients/${clientId}/critical-elements/${year}`;

/**
 * Gets the base path to the list of critical elements by removing the last segment from the current URL
 * @param {string} path Current URL
 * @returns {string} Base path to the list of critical elements
 */
export const getPathToElements = (path) => {
  const parts = path.split('/');
  const clientIdIndex = parts.indexOf('clients') + 1;
  const criticalElementsIndex = parts.indexOf('critical-elements');
  const clientId = parts[clientIdIndex];

  if (
    criticalElementsIndex !== -1 &&
    parts.length > criticalElementsIndex + 1
  ) {
    const year = parts[criticalElementsIndex + 1];

    if (!isNaN(parseInt(year, 10))) {
      return getCommonRedirectLink(clientId, year);
    }
  }

  return getCommonRedirectLink(clientId, '');
};

/**
 * Gets the identifier from the last segment of the URL
 * @param {string} path Current URL
 * @returns {string|number} Element ID or empty string
 */
export const getLastPathSegment = (path) => {
  const pathSegments = path.split('/').filter((segment) => segment !== '');

  return !!pathSegments.length ? pathSegments[pathSegments.length - 1] : '';
};

/**
 * Prepares critical element data for sending to the server
 * @param {Object} params Parameters for data preparation
 * @returns {Object} Prepared data for sending
 */
export const prepareElementPayload = ({ userId, clientId, data, formData }) => {
  const id = data?.id || undefined;

  return {
    userId,
    clientId,
    id,
    elementData: {
      ...formData,
      id,
      details: formData.details.map((item) => ({
        ...item,
        options: Array.isArray(item.options)
          ? item.options
          : item.options
          ? [item.options]
          : [],
      })),
    },
  };
};

export const getBreadcrumbsForCriticalElement = (currentClient, year) => [
  { label: 'Clients', href: '/admin/clients' },
  {
    label: currentClient?.name || '',
    href: `/admin/clients/${currentClient?.id}`,
  },
  {
    label: 'Critical Elements',
    href: getCommonRedirectLink(currentClient?.id, year),
  },
];
